import React, { Fragment, useState } from "react";
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import FontAwesome from "../../components/UiStyle/FontAwesome";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { totalPrice } from "../../utils";
import MosqueMap from "./MosqueMap";
import { useCreateOrder, useGetMosques } from "../../api/useApi";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";
import CheckWrap from "../CheckWrap";
import "./style.scss";
import visa from "../../images/icon/visa.png";
import mastercard from "../../images/icon/mastercard.png";
import bank from "../../images/icon/bank.svg";
import stcpay from "../../images/icon/stc-pay.svg";
import applepay from "../../images/icon/apple-pay.svg";
import mada from "../../images/icon/mada.svg";
import AuthModal from "../AuthModal/AuthModal";
const DEFAULT_MOSQUE_ID = "67ce2a402d4efd72cab27b4e";
const cardType = [
  {
    value: "creditcard",
    img: visa,
  },
  {
    value: "mada",
    img: mada,
  },
  {
    value: "mastercard",
    img: mastercard,
  },
  {
    value: "bank",
    img: bank,
  },
  {
    value: "stcpay",
    img: stcpay,
  },
  {
    value: "applepay",
    img: applepay,
  },
];
const CheckoutSection = ({ cartList }) => {
  const { mutateAsync: createOrder } = useCreateOrder();
  const { data: mosques, isLoading } = useGetMosques();
  const navigate = useNavigate();
  const [selectedMosque, setSelectedMosque] = React.useState(DEFAULT_MOSQUE_ID);
  const [authModalOpen, setAuthModalOpen] = useState(false); // New state for login modal

  const [loading, setLoading] = React.useState(false);
  const { t } = useTranslation();
  const { lang } = useLang();

  const [tabs, setExpanded] = React.useState({
    cupon: false,
    billing_adress: false,
    payment: true,
  });
  const [forms, setForms] = React.useState({
    cupon_key: "",
    payment_method: "bank",
  });

  function faqHandler(name) {
    setExpanded({
      cupon: false,
      billing_adress: false,
      payment: true,
      [name]: !tabs[name],
    });
  }
  const handleCloseLoginModal = () => {
    setAuthModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const authToken = Cookies.get("authToken");

    if (!authToken) {
      toast.error(t(`loginToOrder`));
      setAuthModalOpen(true);
      setLoading(false);
      return;
    }

    if (!selectedMosque) {
      toast.error(t(`selectOrderError`));
      setLoading(false);
      return;
    }

    const orderDetails = {
      totalAmount: totalPrice(cartList),
      paymentMethod:
        forms.payment_method === "mastercard" || forms.payment_method === "mada"
          ? "creditcard"
          : forms.payment_method,
      mosque: selectedMosque,
      products: cartList.map((product) => ({
        product: product.id,
        quantity: product.qty,
      })),
    };

    try {
      const { data } = await createOrder(orderDetails);
      const { _id, totalAmount } = data.order;
      if (forms.payment_method === "bank") navigate("/order_received");
      else if (forms.payment_method === "stcpay")
        navigate(`/payment-stcpay?orderid=${_id}&amount=${totalAmount}`);
      else if (forms.payment_method === "applepay")
        navigate(`/payment-applepay?orderid=${_id}&amount=${totalAmount}`);
      else if (
        forms.payment_method === "creditcard" ||
        forms.payment_method === "mastercard" ||
        forms.payment_method === "mada"
      )
        navigate(`/payment-creditcard?orderid=${_id}&amount=${totalAmount}`);
    } catch (error) {
      toast.error(error.response?.data?.message || t(`orderError`));
      setLoading(false);
    }
  };

  return (
    <section className="wpo-contact-pg-section section-padding">
      <Fragment>
        <Grid className="checkoutWrapper section-padding">
          <Grid className="container" container spacing={3}>
            <Grid item md={6} xs={12}>
              <div className="check-form-area">
                <Grid className="cuponWrap checkoutCard">
                  <FormControl fullWidth margin="normal">
                    <InputLabel>{t(`selectMosque`)}</InputLabel>
                    <Select
                      value={selectedMosque}
                      onChange={(e) => setSelectedMosque(e.target.value)}
                    >
                      {isLoading ? (
                        <MenuItem disabled>{t(`loading`)}</MenuItem>
                      ) : (
                        mosques?.map((mosque) => (
                          <MenuItem key={mosque._id} value={mosque._id}>
                            {mosque.name} - {mosque.address}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid className="cuponWrap checkoutCard">
                  <Button
                    className="collapseBtn"
                    fullWidth
                    onClick={() => faqHandler("payment")}
                  >
                    {t(`paymentMethod`)}
                    <FontAwesome name={tabs.payment ? "minus" : "plus"} />
                  </Button>
                  <Grid className="chCardBody">
                    <Collapse in={tabs.payment} timeout="auto">
                      <Grid className="cardType">
                        {cardType.map((item, i) => (
                          <Grid
                            key={i}
                            className={`cardItem ${
                              forms.payment_method === item.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              setForms({ ...forms, payment_method: item.value })
                            }
                          >
                            <img src={item.img} alt={item.value} width={40} />
                          </Grid>
                        ))}
                      </Grid>

                      <CheckWrap
                        loading={loading}
                        handleSubmit={handleSubmit}
                      />
                    </Collapse>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            <Grid item md={6} xs={12}>
              <Grid className="cartStatus">
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Grid className="cartTotals">
                      <h4 className="title">{t(`cartTotals`)}</h4>
                      <Table>
                        <TableBody>
                          {cartList.map((item) => (
                            <TableRow key={item.id}>
                              <TableCell
                                align={lang === "ar" ? "right" : "left"}
                              >
                                <span className="main-title">{item.title}</span>{" "}
                                {item.price} × {item.qty} {t("currency")}
                              </TableCell>
                              <TableCell
                                align={lang === "ar" ? "left" : "right"}
                              >
                                {item.qty * item.price} {t("currency")}
                              </TableCell>
                            </TableRow>
                          ))}
                          <TableRow className="totalProduct">
                            <TableCell align={lang === "ar" ? "right" : "left"}>
                              <span className="title">{t(`totalProduct`)}</span>{" "}
                            </TableCell>
                            <TableCell align={lang === "ar" ? "left" : "right"}>
                              {cartList.length}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align={lang === "ar" ? "right" : "left"}>
                              <span className="title">{t(`subtotal`)}</span>{" "}
                            </TableCell>
                            <TableCell align={lang === "ar" ? "left" : "right"}>
                              {totalPrice(cartList)} {t("currency")}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align={lang === "ar" ? "right" : "left"}>
                              <span className="title">{t(`totalPrice`)}</span>{" "}
                            </TableCell>
                            <TableCell align={lang === "ar" ? "left" : "right"}>
                              {totalPrice(cartList)} {t("currency")}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <AuthModal open={authModalOpen} handleClose={handleCloseLoginModal} />
      </Fragment>
      {/* Render Map */}

      {mosques && (
        <section className="wpo-contact-map-section">
          <div className="wpo-contact-map">
            <MosqueMap mosques={mosques} onSelectMosque={setSelectedMosque} />
          </div>
        </section>
      )}
    </section>
  );
};

export default CheckoutSection;
